import CustomerNameWithMenu from '../components/CustomerNameWithMenu';

export default function Website() {
  return (
    <div style={{ padding: '1rem' }}>
     
    </div>
  );
}